import { render, staticRenderFns } from "./Eras.vue?vue&type=template&id=f609ecc4&"
import script from "./Eras.vue?vue&type=script&lang=js&"
export * from "./Eras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports